(() => {
  if (customElements.get("p-tab-thumbs-2")) return;

  class PTabThumbs2 extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.tabSwiper = null;
      this.boundResize = this.handleResize.bind(this);
      this.stageTimers = [];
      this.autoPlayTimer = null;
    }

    connectedCallback() {
      this.autoplayEnabled = this.dataset.autoplay === "true";
      this.tabs = Array.from(this.querySelectorAll("[data-tab-index]"));
      
      // tab切换这四部分内容分别更新
      this.mainItems = Array.from(this.querySelectorAll("[data-main-index]"));
      this.copy1Items = Array.from(this.querySelectorAll("[data-copy1-index]"));
      this.copy2Items = Array.from(this.querySelectorAll("[data-copy2-index]"));
      this.bgItems = Array.from(this.querySelectorAll("[data-bg-index]"));

      this.tabsSwiperEl = this.querySelector(".p-tab-thumbs-2__tabs-swiper--m");
      this.paginationEl = this.querySelector(".swiper-pagination");
      this.prevEl = this.querySelector(".swiper-button-prev");
      this.nextEl = this.querySelector(".swiper-button-next");
      this.contentEls = Array.from(this.querySelectorAll("[data-active-index]"));
      this.maxIndex = this.resolveMaxIndex();

      this.bindEvents();
      this.switchTo(0, false);
      this.waitForSwiper(() => {
        this.handleResize();
        window.addEventListener("resize", this.boundResize);
      });
    }

    disconnectedCallback() {
      this.clearStageTimers();
      this.stopAutoPlay();
      window.removeEventListener("resize", this.boundResize);
      this.destroySwiper();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const nextIndex = Number(tab.dataset.tabIndex || 0);
          this.switchTo(nextIndex, true);
        });
      });
    }

    resolveMaxIndex() {
      const indexSet = new Set();
      this.tabs.forEach((tab) => {
        const index = Number(tab.dataset.tabIndex);
        if (Number.isInteger(index)) indexSet.add(index);
      });
      return indexSet.size ? Math.max(...indexSet) : -1;
    }

    waitForSwiper(callback, retry = 0) {
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (retry > 20) return;
      setTimeout(() => this.waitForSwiper(callback, retry + 1), 120);
    }

    isMobile() {
      return window.innerWidth <= 767;
    }

    handleResize() {
      if (!this.tabsSwiperEl) return;
      if (this.isMobile()) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.tabSwiper || typeof window.Swiper !== "function") return;
      this.tabSwiper = new window.Swiper(this.tabsSwiperEl, {
        slidesPerView: 2.5,
        spaceBetween: 11,
        watchOverflow: true,
        speed: 500,
        allowTouchMove: true,
        centeredSlides: false,
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl
        },
        pagination: {
          el: this.paginationEl,
          type: "progressbar"
        },
        on: {
          slideChange: () => {
            const nextIndex = this.tabSwiper ? this.tabSwiper.activeIndex : 0;
            if (nextIndex !== this.activeIndex) {
              this.switchTo(nextIndex, true);
            }
          }
        }
      });
    }

    destroySwiper() {
      if (!this.tabSwiper) return;
      this.tabSwiper.destroy(true, true);
      this.tabSwiper = null;
    }

    clearStageTimers() {
      this.stageTimers.forEach((timer) => clearTimeout(timer));
      this.stageTimers = [];
    }

    startAutoPlay() {
      if (!this.autoplayEnabled) return;
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        let nextIndex = this.activeIndex + 1;
        if (nextIndex > this.maxIndex) {
          nextIndex = 0;
        }
        this.switchTo(nextIndex, true);
      }, 3000);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    }

    resetAutoPlay() {
      this.startAutoPlay();
    }

    switchTo(index, animate) {
      if (!Number.isInteger(index) || index < 0 || index > this.maxIndex) return;
      this.activeIndex = index;
      this.contentEls.forEach((contentEl) => {
        contentEl.dataset.activeIndex = String(index);
      });

      this.tabs.forEach((tab) => {
        tab.classList.toggle("is-active", Number(tab.dataset.tabIndex) === index);
      });

      this.clearStageTimers();
      this.resetAutoPlay();

      if (animate) {
        // 顺序是这里代码依次执行控制：mainItems、bgItems、copy2Items、copy1Items
        // is-reveal-stage-N 类是用来控制入场动画效果的
        this.setActiveByIndex(this.mainItems, index, "is-active", "is-reveal-stage-1");
        
        this.resetElements(this.bgItems);
        this.resetElements(this.copy2Items);
        this.resetElements(this.copy1Items);

        this.addRevealStageByIndex(this.bgItems, index, "is-active");
        this.addRevealStageByIndex(this.bgItems, index, "is-reveal-stage-2");

        this.stageTimers.push(
          setTimeout(() => {
            this.addRevealStageByIndex(this.copy2Items, index, "is-active");
            this.addRevealStageByIndex(this.copy2Items, index, "is-reveal-stage-3");
          }, 250)
        );

        this.stageTimers.push(
          setTimeout(() => {
            this.addRevealStageByIndex(this.copy1Items, index, "is-active");
            this.addRevealStageByIndex(this.copy1Items, index, "is-reveal-stage-2");
          }, 500)
        );
      } else {
        this.setActiveByIndex(this.mainItems, index, "is-active", "is-reveal-stage-1");
        this.setActiveByIndex(this.bgItems, index, "is-active", "is-reveal-stage-2");
        this.setActiveByIndex(this.copy1Items, index, "is-active", "is-reveal-stage-2");
        this.setActiveByIndex(this.copy2Items, index, "is-active", "is-reveal-stage-3");
      }

      if (this.tabSwiper) {
        this.tabSwiper.slideTo(index);
      }
    }

    resetElements(elements) {
      elements.forEach((item) => {
        item.classList.remove("is-active", "is-reveal-stage-1", "is-reveal-stage-2", "is-reveal-stage-3");
      });
    }

    addRevealStageByIndex(elements, index, stageClass) {
      elements.forEach((item) => {
        if (this.resolveItemIndex(item) === index) {
          item.classList.add(stageClass);
        }
      });
    }

    resolveItemIndex(item) {
      if (item.dataset.mainIndex !== undefined) return Number(item.dataset.mainIndex);
      if (item.dataset.copy1Index !== undefined) return Number(item.dataset.copy1Index);
      if (item.dataset.copy2Index !== undefined) return Number(item.dataset.copy2Index);
      if (item.dataset.bgIndex !== undefined) return Number(item.dataset.bgIndex);
      return null;
    }

    setActiveByIndex(elements, index, baseClass, stageClass) {
      elements.forEach((item) => {
        const itemIndex = this.resolveItemIndex(item);

        item.classList.remove(baseClass);
        item.classList.remove("is-reveal-stage-1");
        item.classList.remove("is-reveal-stage-2");
        item.classList.remove("is-reveal-stage-3");

        if (itemIndex === index) {
          item.classList.add(baseClass);
          if (stageClass) item.classList.add(stageClass);
        }
      });
    }
  }

  customElements.define("p-tab-thumbs-2", PTabThumbs2);
})();
